import { useEffect, useState } from "react";
import { Copy, Check, ExternalLink } from "lucide-react";
import { PARTNER_LINK, DISCOUNT_CODE } from "@/lib/constants";
import { trackEvent } from "@/lib/tracking";

const MobileStickyCTA = () => {
  const [visible, setVisible] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    // Show only after the user scrolls past ~70% of viewport (out of hero)
    const onScroll = () => {
      setVisible(window.scrollY > window.innerHeight * 0.7);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleCopy = () => {
    navigator.clipboard?.writeText(DISCOUNT_CODE);
    setCopied(true);
    trackEvent("code_copy", "sticky_mobile");
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div
      aria-hidden={!visible}
      className={`fixed inset-x-0 bottom-0 z-40 border-t border-border/60 bg-background/95 backdrop-blur-md px-3 py-2.5 shadow-[0_-4px_16px_rgba(0,0,0,0.25)] transition-transform duration-300 md:hidden ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <div className="flex items-center gap-2">
        <button
          onClick={handleCopy}
          className="inline-flex flex-1 items-center justify-center gap-1.5 rounded-lg border border-border bg-card px-3 py-2.5 text-sm font-bold tracking-wider text-primary transition-colors hover:bg-secondary"
          aria-label="Rabattcode LONGEVITY kopieren"
        >
          {copied ? (
            <>
              <Check className="h-3.5 w-3.5 text-success" aria-hidden="true" />
              <span className="text-success">Kopiert</span>
            </>
          ) : (
            <>
              <Copy className="h-3.5 w-3.5" aria-hidden="true" />
              {DISCOUNT_CODE}
            </>
          )}
        </button>
        <a
          href={PARTNER_LINK}
          target="_blank"
          rel="noopener noreferrer nofollow"
          onClick={() => trackEvent("affiliate_click", "sticky_mobile")}
          className="inline-flex flex-1 items-center justify-center gap-1.5 rounded-lg bg-primary px-3 py-2.5 text-sm font-semibold text-primary-foreground shadow-md shadow-primary/25 transition-all hover:brightness-110"
        >
          Zum Shop
          <ExternalLink className="h-3.5 w-3.5" aria-hidden="true" />
        </a>
      </div>
    </div>
  );
};

export default MobileStickyCTA;
